// extracted by mini-css-extract-plugin
export var actionText = "_nf-4";
export var container = "_nf-0";
export var leftSection = "_nf-1";
export var rightSection = "_nf-2";
export var settingsButton = "_nf-6";
export var settingsIcon = "_nf-7";
export var shortcut = "_nf-5";
export var shortcutGroup = "_nf-3";